import React from "react";
import "./EventHeroVideo.css";
import parse from "html-react-parser";
import VideoBackground from "../VideoBackground";

function EventHeroVideo({ heading, body, colors: colorObj, contents: contentsArray }) {
    const videoSrc = contentsArray?.[0]?.content_reference;
    return (
        <div className="row">
            <div className="col-12">
                <section className="EventHeroVideoMain" data-aos="fade-up">
                    <VideoBackground src={videoSrc} className="heroVideo" />
                    <div className="container textMainHldr">
                        <div className="row">
                            <div className="col-lg-12 col-md-12 col-sm-12 col-12 text-center">
                                <h2 style={{ color: colorObj?.accent_color4 }}>{heading}</h2>
                                {body !== "" && (
                                    <p style={{ color: colorObj?.accent_color4 }}>{parse(body)}</p>
                                )}
                            </div>
                        </div>
                    </div>
                </section>
            </div>
        </div>
    );
}

export default EventHeroVideo;
